<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu></dingbu>
    <div class="home_content" style="min-height: 560px">
      <div class="bg_color">
        <div class="w">
          <div class="submit__title">确认订单信息</div>
          <div class="store_border">
            <div class="buy__count">
              <div class="buy_itemss">购买账号: {{ username }}</div>
            </div>
            <div class="ke__boxs">
              <div class="lfet_kes">
                <img :src="study.image" alt="" />
                <div class="rih__txts">
                  <div class="title_ke">{{ study.examname }}</div>
                  <div class="keshi__time">{{ study.class_hour }} 课时</div>
                </div>
              </div>
              <div class="riht__pays">
                <div class="pay__names">应付金额</div>
                <div class="pay_moneys">
                  {{ study.study_price }} <span>元</span>
                </div>
              </div>
            </div>
          </div>

          <div class="kai__fapiao">
            <div class="img_kai" @click.stop="openinvoice">
              <img
                src="../../assets/img/jin_5.png"
                alt=""
                v-if="params.invoice_status == 1"
              />
              <img src="../../assets/img/jin_4.png" alt="" v-else />
            </div>
            <div class="kai__names">开发票</div>
          </div>
          <el-form>
            <div class="fapiao_text" v-if="params.invoice_status == 1">
              <div class="form__boxs">
                <div class="piao__box">
                  <div class="icon_named"><span>*</span>发票类型</div>
                  <div class="span__nam">
                    <div class="changed__icon">
                      <!-- <img
                        src="../../assets/img/jin_5.png"
                        alt=""
                        v-if="is_change == true"
                      /> -->
                      <img src="../../assets/img/jin_5.png" alt="" />
                    </div>
                    <div class="span__iconname">增值税纸质普通发票</div>
                  </div>
                </div>
                <div class="piao__box">
                  <div class="icon_named">
                    <span style="color: #fff">*</span>抬头类型
                  </div>
                  <div class="span__nam" @click.stop="changeRise(0)">
                    <div class="changed__icon">
                      <img
                        src="../../assets/img/jin_5.png"
                        alt=""
                        v-if="is_change == true"
                      />
                      <img src="../../assets/img/jin_4.png" alt="" v-else />
                    </div>
                    <div class="span__iconname">个人</div>
                  </div>
                  <div
                    class="span__nam"
                    style="margin-left: 50px"
                    @click.stop="changeRise(1)"
                  >
                    <div class="changed__icon">
                      <img
                        src="../../assets/img/jin_5.png"
                        alt=""
                        v-if="is_changd == true"
                      />
                      <img src="../../assets/img/jin_4.png" alt="" v-else />
                    </div>
                    <div class="span__iconname">企业</div>
                  </div>
                </div>
                <div class="piao__box">
                  <div class="icon_named"><span>*</span>发票抬头</div>
                  <div class="code_input">
                    <el-input
                      placeholder="请输入发票抬头"
                      class="el__input_o"
                      v-model="params.title"
                    ></el-input>
                  </div>
                </div>
                <div class="piao__box">
                  <div class="icon_named"><span>*</span>税号</div>
                  <div class="code_input">
                    <el-input
                      placeholder="请输入税号"
                      class="el__input_o"
                      v-model="params.tax_number"
                    ></el-input>
                  </div>
                </div>
                <div class="piao__box">
                  <div class="icon_named"><span>*</span>电子邮箱</div>
                  <div class="code_input">
                    <el-input
                      placeholder="请输入电子邮箱"
                      class="el__input_o"
                      v-model="params.email"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit__title">请选择支付方式</div>
            <div class="status__box">
              <div class="pay_state">
                <div
                  class="pay_tiems"
                  :class="index == currentIndex ? 'changed_box' : ''"
                  v-for="(item, index) in payState"
                  :key="index"
                  @click.stop="changePay(index)"
                >
                  <img :src="item.icon" class="item__icon" alt="" />
                  <div class="pay__name">{{ item.payname }}</div>
                  <img
                    src="../../assets/img/jin_9.png"
                    class="changed__icon"
                    v-if="index == currentIndex"
                    alt=""
                  />
                </div>
              </div>

              <div class="down_paytotal">
                <div class="left_wns">
                  <span class="shifu">实付金额：</span>
                  <span class="shi__total">{{ payprice }}元</span>
                </div>
                <div class="pay__botton">
                  <el-button class="el_tton" @click.stop="startPay"
                    >立即支付</el-button
                  >
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <dibu></dibu>
    <daohan ref="mychild"></daohan>
    <div class="wechat_pay" v-if="wechatpay == true">
      <div class="we_chat"></div>
      <div class="chat__img">
        <div class="close_img">
          <img src="../../assets/guanbi_icon@2x (2).png" alt="" />
        </div>
        <div class="title_name">微信支付</div>
        <div class="wechat__img">
          <img src="../../assets/erweima_img@2x.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      bei_ing: this.Public.bei_ing,
      payState: this.Public.payState,
      payprice: '',
      username: '',
      study: {},
      params: {
        study_id: '',
        pay_type: 'wechat',   //	支付方式:wechat=微信,alipay=支付宝
        invoice_status: '',   //	是否开发票:0=否,1=是
        type: '1',   //	发票类型:1=增值税普通发票,2=增值税专用发票
        title_type: '1',   //抬头类型:1=个人,2=公司 
        title: '',   //发票抬头
        tax_number: '',  //税号
        email: '',   //	电子邮箱
      },
      currentIndex: 0,
      is_changd: false,
      is_change: true,
      wechatpay: false,
    }
  },
  created() {
    let query = this.$route.query
    // console.log(query);
    this.params.study_id = query.id
    this.getsubmit()
  },
  methods: {
    async getsubmit() {
      let that = this, url = "user/studyPayView", param = {
        study_id: that.params.study_id
      };
      try {
        const { data } = await that.post(url, param)
        // console.log(data, "购买课程");
        this.payprice = data.pay_price
        this.study = data.study
      } catch (err) {
        // console.log(err);
      }
    },
    changePay(i) {
      this.currentIndex = i
      this.params.pay_type = this.payState[i].pay_id
    },
    openinvoice() {
      if (this.params.invoice_status == 0) {
        this.params.invoice_status = 1
      } else {
        this.params.invoice_status = 0
      }
    },
    async startPay() {
      // console.log(this.params);
      let that = this, url = "user/studyPay", param = this.params;
      try {
        const { data } = await that.post(url, param)
        // console.log(data, "提交支付");
        var { href } = this.$router.resolve({
          path: '/newpage',
          query: {
            htmls: data
          }
        });
        // console.log(href);
        // window.open(href, '_blank');
        window.location.href = href

      } catch (err) {
        // console.log(err);
      }
    },
    changeRise(t) {
      let td = t
      if (td == 0) {
        this.is_change = true
        this.is_changd = false
        this.params.title_type = 1
      } else {
        this.is_changd = true
        this.is_change = false
        this.params.title_type = 2
      }
    },
    async alipayZFB() {
      const { data: { data } } = await this.$http.post(
        "api/order/orderPay", { order_id: this.order_id }
      )
      // console.log(data);
      var { href } = this.$router.resolve({
        path: '/newpage',
        query: {
          htmls: data.result
        }
      });
      // window.open(href, '_blank');
      window.location.href = href
    },
  },

}
</script>

<style lang="less" scoped>
.container {
  //   第三部分

  .home_content {
    width: 100%;
    padding-bottom: 50px;
    box-sizing: border-box;

    .bg_color {
      width: 100%;
      height: 100%;

      .submit__title {
        width: 100%;
        height: 56px;
        opacity: 1;
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: left;
        color: #06121e;
        line-height: 56px;
      }

      .store_border {
        width: 100%;
        border: 1px solid #eee;

        .buy__count {
          width: 100%;
          background-color: #eeeeee;
          height: 40px;
          .buy_itemss {
            width: 100%;
            opacity: 1;
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #06121e;
            line-height: 40px;
            padding: 0 16px;
            box-sizing: border-box;
          }
        }

        .ke__boxs {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          box-sizing: border-box;
          background-color: #fff;

          .lfet_kes {
            flex: 1;
            display: flex;
            align-items: center;

            img {
              width: 134px;
              height: 88px;
              border-radius: 8px;
              flex-shrink: 0;
            }

            .rih__txts {
              flex: 1;
              padding: 6px 16px;
              box-sizing: border-box;
              height: 88px;
              display: flex;
              //  align-items: center;
              flex-direction: column;
              justify-content: space-between;

              .title_ke {
                width: 100%;
                font-size: 16px;
                font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 600;
                text-align: left;
                color: #06121e;
                line-height: 22px;
              }

              .keshi__time {
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                text-align: left;
                color: #06121e;
                line-height: 22px;
              }
            }
          }

          .riht__pays {
            width: 204px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-left: 1px solid #eeeeee;
            box-sizing: border-box;
            height: 88px;

            .pay__names {
              width: 100%;
              font-size: 16px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 600;
              text-align: center;
              color: #06121e;
              line-height: 22px;
            }

            .pay_moneys {
              font-size: 24px;
              font-family: DINPro, DINPro-Bold;
              font-weight: 700;
              text-align: center;
              color: #ff1027;
              line-height: 22px;
              margin-top: 10px;
              span {
                font-size: 24px;
                font-family: DINPro, DINPro-Bold;
                font-weight: 700;
                text-align: center;
                color: #ff1027;
                line-height: 22px;
              }
            }
          }
        }
      }

      .kai__fapiao {
        width: 100%;
        display: flex;
        align-items: center;
        height: 40px;

        .img_kai {
          width: 14px;
          margin-right: 16px;
          img {
            width: 100%;
            height: 14px;
          }
        }

        .kai__names {
          flex: 1;
          display: flex;
          align-items: center;
          opacity: 1;
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 600;
          text-align: left;
          color: #06121e;
          line-height: 22px;
        }
      }

      .fapiao_text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        padding: 32px;
        box-sizing: border-box;

        .form__boxs {
          width: 800px;
          padding: 18px;
          box-sizing: border-box;
          // background-color: #f9f9f9;
          border-radius: 8px;

          .piao__box {
            width: 100%;
            display: flex;
            align-items: center;
            height: 40px;
            // background-color: #f9f9f9;
            .icon_named {
              width: 130px;
              span {
                color: #ff1027;
              }
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              line-height: 22px;
            }
            .span__nam {
              display: flex;
              align-items: center;
              .changed__icon {
                width: 14px;
                img {
                  width: 100%;
                  height: 14px;
                }
              }

              .span__iconname {
                flex: 1;
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                text-align: left;
                color: #06121e;
                line-height: 40px;
                margin-left: 8px;
              }
            }

            .code_input {
              flex: 1;
            }
          }
        }
      }

      .status__box {
        width: 100%;
        background-color: #fff;
        padding: 16px;
        box-sizing: border-box;

        .pay_state {
          width: 100%;
          display: flex;
          align-items: center;

          .pay_tiems {
            width: 135px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #eee;
            margin-right: 16px;
            background-color: #fff;
            box-sizing: border-box;

            .item__icon {
              width: 16px;
              height: 16px;
              margin-right: 8px;
            }

            .pay__name {
              font-size: 14px;
              color: #06121e;
            }
          }
          .changed_box {
            width: 135px;
            border: 1px solid #3e8bff;
            position: relative;
            box-sizing: border-box;

            .changed__icon {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 21px;
              height: 21px;
            }
          }
        }

        .down_paytotal {
          width: 100%;
          padding: 16px 24px 16px 0;
          box-sizing: border-box;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
          border-top: 1px solid #f9f9f9;

          .left_wns {
            flex: 1;
            display: flex;
            align-items: center;
            height: 46px;

            .shifu {
              font-size: 16px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 600;
              text-align: left;
              color: #06121e;
            }
            .shi__total {
              font-size: 20px;
              font-family: DINPro, DINPro-Bold;
              font-weight: 700;
              text-align: left;
              color: #ff1027;
              margin-left: 6px;
            }
          }

          .pay__botton {
            background-color: #3e8bff;

            .el_tton {
              background-color: #3e8bff;
              color: #fff;
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .wechat_pay {
    .we_chat {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      background: #000;
      opacity: 0.5;
    }

    .chat__img {
      width: 400px;
      background-color: #fff;
      border-radius: 16px;
      box-sizing: border-box;
      padding: 16px;
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 15;
      transform: translate(-50%, -50%);

      .close_img {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 36px;
          height: 36px;
        }
      }
      .title_name {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: #06121e;
      }

      .wechat__img {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>